module.exports = __webpack_public_path__ + "static/11-4d1f30e920d1a75596de65b2ca4e1dc3.png";